export default {
  // 设置一级分类列表
  setCategoryTree(state, payload) {
    state.categoryTree = payload;
  },
  // 设置分类表单数据
  setCategoryForm(state, payload) {
    state.categoryForm = payload;
  },
  // 设置当前登录的用户信息
  setUserInfo(state, payload) {
    state.userInfo = payload;
  },
  // 设置协议内容
  setProtocol(state, payload) {
    state.protocol = payload;
  },
  // 设置菜单
  setMenu(state, payload) {
    state.menuList = payload;
  },
  setMenuIds(state, payload) {
    state.menuIds = payload;
  },
  setAddressTree(state, payload) {
    state.addressTree = payload;
  },
  update_operation_list(state, payload) {
    state.operationList = payload;
  },
  update_permission_list(state, payload) {
    state.permissionList = payload;
  },
  updateLoginData(state, payload) {
    state.loginData = payload;
  },
};